import React, { Component } from 'react';
import { replace } from 'react-router-redux';
import PropTypes from 'prop-types';

import Salesforce from './Salesforce';

export default class Projects extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Salesforce = Salesforce

  componentDidMount() {
    const { store } = this.context;
    const { children } = this.props;
    if (!children) {
      store.dispatch(replace('/'));
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/containers/Integrations/Integrations.jsx